import React from 'react';
import {Box, Typography} from "@mui/material";
import CardIcon from "../icons/CardIcon";
import useSystemTheme from "../../../hooks/useSystemTheme";

const PaymentStatusTag = ({paymentMethod}) => {
    const {isDarkMode} = useSystemTheme();
    const validPaymentMethod =
        paymentMethod && paymentMethod !== "undefined" && paymentMethod !== "undefinedundefined"
            ? paymentMethod
            : null;

    return (
        <Box
            display="flex"
            alignItems="center"
            gap="8px"
        >
            <Box
                display="flex"
                alignItems="center"
                alignContent="center"
                width="24px"
                height="24px"
                bgcolor={isDarkMode ? "#001489" : "transparent"}
                borderRadius="50%"
                padding="2px"
            >
                <CardIcon strokeColor={isDarkMode ? "#FFFFFF" : "#001489"}/>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
            >
                <Typography
                    color={isDarkMode ? "#FFFFFF" : "#000000"}
                    fontWeight={400}
                    fontSize={16}
                    lineHeight={1}
                    fontFamily="'Outfit', sans-serif"
                > {validPaymentMethod ? "Done" : "Pending"}
                </Typography>
                {validPaymentMethod && <Typography
                    color={"#878787"}
                    fontWeight={400}
                    fontSize={12}
                    fontFamily="'Outfit', sans-serif"
                >{validPaymentMethod}
                </Typography>
                }
            </Box>
        </Box>
    );
}

export default PaymentStatusTag;